import React, { useState } from 'react';
import { ModernNavigation } from '../components/modern/ModernNavigation';
import { ModernFooter } from '../components/modern/ModernFooter';
import '../css/modern-design-system.css';
import '../css/modern-download.css';

export function ModernDownloadPage() {
  const [scrolled, setScrolled] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState<'ios' | 'android'>('ios');

  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="modern-download-page">
      <ModernNavigation scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="download-hero-modern">
        <div className="hero-bg-pattern"></div>
        <div className="container">
          <div className="download-hero-content">
            <div className="download-hero-text animate-fadeIn">
              <div className="platform-badge">
                <span className="badge-icon">📱</span>
                <span>Available on iOS & Android</span>
              </div>
              
              <h1 className="download-hero-title">
                Download <span className="text-gradient">EquityWorkx</span>
                <br />
                Protect Your Home, <span className="text-gradient">Grow Your Wealth</span>
              </h1>

              <p className="download-hero-subtitle">
                Get personalized insights that help you avoid unnecessary fees, protect your
                credit score, and discover savings opportunities before they pass you by.
              </p>
              
              <div className="download-stats-row">
                <div className="download-stat">
                  <div className="stat-icon">⭐</div>
                  <div className="stat-info">
                    <span className="stat-number">4.9</span>
                    <span className="stat-text">App Store Rating</span>
                  </div>
                </div>
                <div className="download-stat">
                  <div className="stat-icon">📥</div>
                  <div className="stat-info">
                    <span className="stat-number">50K+</span>
                    <span className="stat-text">Downloads</span>
                  </div>
                </div>
                <div className="download-stat">
                  <div className="stat-icon">🏆</div>
                  <div className="stat-info">
                    <span className="stat-number">#1</span>
                    <span className="stat-text">Finance App 2024</span>
                  </div>
                </div>
              </div>
              
              <div className="download-buttons-modern">
                <a 
                  href="https://apps.apple.com" 
                  className="download-btn-modern ios"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="btn-icon">
                    <svg width="28" height="28" viewBox="0 0 384 512" fill="currentColor">
                      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
                    </svg>
                  </div>
                  <div className="btn-text">
                    <span className="btn-label">Download on the</span>
                    <span className="btn-title">App Store</span>
                  </div>
                </a>
                
                <a 
                  href="https://play.google.com" 
                  className="download-btn-modern android"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="btn-icon">
                    <svg width="28" height="28" viewBox="0 0 512 512" fill="currentColor">
                      <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
                    </svg>
                  </div>
                  <div className="btn-text">
                    <span className="btn-label">Get it on</span>
                    <span className="btn-title">Google Play</span>
                  </div>
                </a>
              </div>
              
              <div className="qr-code-section">
                <p className="qr-text">Or scan to download:</p>
                <div className="qr-codes">
                  <div className="qr-code-item">
                    <div className="qr-code-placeholder">
                      <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
                        <rect width="100" height="100" fill="url(#qr-gradient)"/>
                        <defs>
                          <linearGradient id="qr-gradient" x1="0" y1="0" x2="100" y2="100">
                            <stop offset="0%" stopColor="#4F46E5"/>
                            <stop offset="100%" stopColor="#7C3AED"/>
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <span>iOS</span>
                  </div>
                  <div className="qr-code-item">
                    <div className="qr-code-placeholder">
                      <svg width="100" height="100" viewBox="0 0 100 100" fill="none">
                        <rect width="100" height="100" fill="url(#qr-gradient2)"/>
                        <defs>
                          <linearGradient id="qr-gradient2" x1="0" y1="0" x2="100" y2="100">
                            <stop offset="0%" stopColor="#06B6D4"/>
                            <stop offset="100%" stopColor="#0891B2"/>
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <span>Android</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="download-hero-visual animate-slideInRight">
              <div className="devices-showcase">
                <div className="device-iphone">
                  <div className="device-frame">
                    <div className="device-screen">
                      <img src="/app-dash.png" alt="EquityWorkx iOS App" />
                    </div>
                  </div>
                </div>
                <div className="device-android">
                  <div className="device-frame">
                    <div className="device-screen">
                      <img src="/app-dash.png" alt="EquityWorkx Android App" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* App Features Section */}
      <section className="app-features-modern">
        <div className="container">
          <div className="section-header-modern">
            <span className="section-label">KEY FEATURES</span>
            <h2 className="section-title-modern">
              Everything You Need in <span className="text-gradient">One App</span>
            </h2>
          </div>
          
          <div className="app-features-grid">
            <div className="app-feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon-bg"></div>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <h3>Protect Your Credit</h3>
              <p>Get alerts before missed payments impact your credit score. Stay ahead of potential issues.</p>
            </div>

            <div className="app-feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon-bg"></div>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 6v6l4 2"/>
                </svg>
              </div>
              <h3>Avoid Hidden Fees</h3>
              <p>Receive proactive insights about escrow changes, rate adjustments, and fees before they hit.</p>
            </div>

            <div className="app-feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon-bg"></div>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </div>
              <h3>Foresight & Insights</h3>
              <p>See refinancing opportunities and savings recommendations tailored to your mortgage.</p>
            </div>

            <div className="app-feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon-bg"></div>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                </svg>
              </div>
              <h3>Track Your Equity</h3>
              <p>Monitor your home equity growth in real-time and see how every payment builds your wealth.</p>
            </div>

            <div className="app-feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon-bg"></div>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <h3>Bank-Level Security</h3>
              <p>Your data is protected with 256-bit encryption and biometric authentication.</p>
            </div>

            <div className="app-feature-card">
              <div className="feature-icon-wrapper">
                <div className="feature-icon-bg"></div>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                </svg>
              </div>
              <h3>Smart Alerts</h3>
              <p>Get timely notifications about rate changes, payment due dates, and money-saving opportunities.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Screenshots Gallery */}
      <section className="screenshots-modern">
        <div className="container">
          <div className="section-header-modern">
            <span className="section-label">APP PREVIEW</span>
            <h2 className="section-title-modern">
              See EquityWorkx in <span className="text-gradient">Action</span>
            </h2>
          </div>
          
          <div className="platform-switcher">
            <button 
              className={`platform-btn ${selectedPlatform === 'ios' ? 'active' : ''}`}
              onClick={() => setSelectedPlatform('ios')}
            >
              <svg width="20" height="20" viewBox="0 0 384 512" fill="currentColor">
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
              </svg>
              iOS
            </button>
            <button 
              className={`platform-btn ${selectedPlatform === 'android' ? 'active' : ''}`}
              onClick={() => setSelectedPlatform('android')}
            >
              <svg width="20" height="20" viewBox="0 0 512 512" fill="currentColor">
                <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
              </svg>
              Android
            </button>
          </div>
          
          <div className="screenshots-carousel">
            <div className="screenshot-item">
              <img src="/app-dash.png" alt="Dashboard" />
              <p>Dashboard</p>
            </div>
            <div className="screenshot-item">
              <img src="/app-dash.png" alt="Analytics" />
              <p>Analytics</p>
            </div>
            <div className="screenshot-item">
              <img src="/app-dash.png" alt="Calculators" />
              <p>Calculators</p>
            </div>
            <div className="screenshot-item">
              <img src="/app-dash.png" alt="Insights" />
              <p>Insights</p>
            </div>
            <div className="screenshot-item">
              <img src="/app-dash.png" alt="Reports" />
              <p>Reports</p>
            </div>
          </div>
        </div>
      </section>

      {/* System Requirements */}
      <section className="requirements-modern">
        <div className="container">
          <div className="requirements-grid">
            <div className="requirement-card">
              <h3>iOS Requirements</h3>
              <ul>
                <li>iOS 14.0 or later</li>
                <li>iPhone 6s or newer</li>
                <li>iPad (6th generation) or newer</li>
                <li>iPod touch (7th generation)</li>
                <li>100 MB of free space</li>
              </ul>
            </div>
            
            <div className="requirement-card">
              <h3>Android Requirements</h3>
              <ul>
                <li>Android 7.0 (API level 24) or higher</li>
                <li>2 GB RAM minimum</li>
                <li>ARM or x86 processor</li>
                <li>150 MB of free space</li>
                <li>Google Play Services</li>
              </ul>
            </div>
            
            <div className="requirement-card">
              <h3>Web App Requirements</h3>
              <ul>
                <li>Chrome 90+ / Safari 14+ / Firefox 88+ / Edge 90+</li>
                <li>JavaScript enabled</li>
                <li>Cookies enabled</li>
                <li>Stable internet connection</li>
                <li>1280x720 minimum resolution</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Download CTA */}
      <section className="download-cta-modern">
        <div className="container">
          <div className="download-cta-content">
            <h2>Take Control of Your <span className="text-gradient">Mortgage Today</span></h2>
            <p>Get the insights you need to protect your finances and uncover savings</p>
            
            <div className="download-buttons-modern centered">
              <a href="https://apps.apple.com" className="download-btn-modern ios large">
                <div className="btn-icon">
                  <svg width="32" height="32" viewBox="0 0 384 512" fill="currentColor">
                    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
                  </svg>
                </div>
                <div className="btn-text">
                  <span className="btn-label">Download on the</span>
                  <span className="btn-title">App Store</span>
                </div>
              </a>
              
              <a href="https://play.google.com" className="download-btn-modern android large">
                <div className="btn-icon">
                  <svg width="32" height="32" viewBox="0 0 512 512" fill="currentColor">
                    <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
                  </svg>
                </div>
                <div className="btn-text">
                  <span className="btn-label">Get it on</span>
                  <span className="btn-title">Google Play</span>
                </div>
              </a>
            </div>
            
            <div className="download-features">
              <span>✓ Free to download</span>
              <span>✓ No credit checks</span>
              <span>✓ Personalized insights</span>
            </div>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
}